import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getVendorById } from '../../Vendors/apiService';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { useUrlParams } from '../../../contexts/UrlParams';


const VendorInfo = () => {
  const { values, setFieldValue } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  const { data: vendor } = useQuery({
    queryKey: ['vendor', values?.vendor_id, values?.invoice_id],
    queryFn: () => getVendorById(values?.vendor_id),
    enabled: !!values?.vendor_id,
    staleTime: Infinity
  });

  useEffect(() => {
    if (vendor) {
      setFormValues(ofv => ({ ...ofv, vendor}));
    }
  }, [vendor]);

  useEffect(() => {
    if (vendor?.final_balance - (values?.total || 0) >= 0) {
      setFieldValue('apply_credit', false);
    } else {
      if (values?.balance > 0) {
        setFieldValue('apply_credit', true);
      }
    }
  }, [vendor, values?.total, values?.balance]);
 
  return null;
};

export default VendorInfo;